import { ChangeEvent } from 'react';
import clsx from 'clsx';

import { TextField } from '@atom/mui';

import classes from '../../formInstance.module.css';

interface PassedProps {
  type: string;
  value: any;
  unit: string;
  isEditable: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type Props = PassedProps;

const NumericAttribute = ({
  type,
  value,
  onChange,
  unit,
  isEditable,
}: Props) => {
  return (
    <div
      className={clsx(
        classes.attributeInput,
        type === 'currency' && classes.currency,
      )}
    >
      <TextField
        variant="standard"
        name={type}
        onChange={onChange}
        value={value}
        type="number"
        disabled={!isEditable}
      />
      {type === 'number' && <div className={classes.unitText}>{unit}</div>}
    </div>
  );
};

export default NumericAttribute;
